// Your GeoJSON data goes here
const geojsonData = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: "sm9a65a9e9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603620499, -1.355000242],
            [36.603576497, -1.356229312],
            [36.604110585, -1.356157533],
            [36.60418412, -1.35494839],
            [36.603620499, -1.355000242],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK33",
      },
    },
    {
      type: "Feature",
      id: "sm51f6a623",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.604186502, -1.354945441],
            [36.60411297, -1.356154582],
            [36.604328942, -1.356125556],
            [36.604313619, -1.356235051],
            [36.604458211, -1.356225063],
            [36.604782244, -1.354865907],
            [36.604186502, -1.354945441],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK32",
      },
    },

    {
      type: "Feature",
      id: "sm05640942",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602782008, -1.361835128],
            [36.602912225, -1.362800507],
            [36.603230379, -1.36276003],
            [36.603488023, -1.361632426],
            [36.603343994, -1.36164774],
            [36.603286565, -1.361767105],
            [36.602782008, -1.361835128],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK05",
      },
    },
    {
      type: "Feature",
      id: "sm2da132b1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601313528, -1.36300391],
            [36.601184911, -1.36205044],
            [36.600847413, -1.362095939],
            [36.60066094, -1.362320707],
            [36.600722252, -1.362985637],
            [36.600728352, -1.36307465],
            [36.600760359, -1.363071244],
            [36.600809248, -1.36306807],
            [36.601313528, -1.36300391],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK01",
      },
    },
    {
      type: "Feature",
      id: "smbbf2443d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601184911, -1.36205044],
            [36.601313528, -1.36300391],
            [36.601852146, -1.362935382],
            [36.601722988, -1.361977896],
            [36.601184911, -1.36205044],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK02",
      },
    },
    {
      type: "Feature",
      id: "smf9358dfc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601722988, -1.361977896],
            [36.601852146, -1.362935382],
            [36.602380274, -1.362868186],
            [36.602250588, -1.361906772],
            [36.601722988, -1.361977896],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK03",
      },
    },
    {
      type: "Feature",
      id: "smcf420924",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602250588, -1.361906772],
            [36.602380274, -1.362868186],
            [36.602912225, -1.362800507],
            [36.602782008, -1.361835128],
            [36.602250588, -1.361906772],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK04",
      },
    },
    {
      type: "Feature",
      id: "sm6d8db0ca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603206236, -1.359267103],
            [36.603354733, -1.360329176],
            [36.603734139, -1.36027616],
            [36.603940882, -1.359044084],
            [36.603771889, -1.359078235],
            [36.603709121, -1.359198166],
            [36.603206236, -1.359267103],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK17",
      },
    },
    {
      type: "Feature",
      id: "sm526d8cec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603354733, -1.360329176],
            [36.603206236, -1.359267103],
            [36.602675967, -1.359339794],
            [36.602821885, -1.360403635],
            [36.603354733, -1.360329176],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK16",
      },
    },
    {
      type: "Feature",
      id: "sm80f03cd7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602821885, -1.360403635],
            [36.602675967, -1.359339794],
            [36.60209999, -1.359418752],
            [36.602246115, -1.360484091],
            [36.602821885, -1.360403635],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK15",
      },
    },
    {
      type: "Feature",
      id: "sm9bf66709",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602246115, -1.360484091],
            [36.60209999, -1.359418752],
            [36.60156748, -1.359491753],
            [36.601713794, -1.360558478],
            [36.602246115, -1.360484091],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK14",
      },
    },
    {
      type: "Feature",
      id: "sm5dcdd753",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601713794, -1.360558478],
            [36.60156748, -1.359491753],
            [36.601043821, -1.359563537],
            [36.601190321, -1.360631627],
            [36.601713794, -1.360558478],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK13",
      },
    },
    {
      type: "Feature",
      id: "sm81605703",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601190321, -1.360631627],
            [36.601043821, -1.359563537],
            [36.600726214, -1.359607077],
            [36.60046926, -1.359828559],
            [36.600532564, -1.360723538],
            [36.601190321, -1.360631627],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK12",
      },
    },
    {
      type: "Feature",
      id: "sm358fdb07",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601232933, -1.361731737],
            [36.601081249, -1.360646869],
            [36.600532564, -1.360723538],
            [36.600597613, -1.36164319],
            [36.600824378, -1.361797047],
            [36.601232933, -1.361731737],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK11",
      },
    },
    {
      type: "Feature",
      id: "sm7ff74e61",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601081249, -1.360646869],
            [36.601232933, -1.361731737],
            [36.601630655, -1.361668156],
            [36.60169983, -1.361658183],
            [36.601544601, -1.36058212],
            [36.601081249, -1.360646869],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK10",
      },
    },
    {
      type: "Feature",
      id: "sm2e803e88",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601544601, -1.36058212],
            [36.60169983, -1.361658183],
            [36.602195444, -1.361586726],
            [36.602045204, -1.360512166],
            [36.601544601, -1.36058212],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK09",
      },
    },
    {
      type: "Feature",
      id: "sm32927241",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602045204, -1.360512166],
            [36.602195444, -1.361586726],
            [36.602679823, -1.36151689],
            [36.602525207, -1.360445093],
            [36.602045204, -1.360512166],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK08",
      },
    },
    {
      type: "Feature",
      id: "sm9f459428",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602525207, -1.360445093],
            [36.602679823, -1.36151689],
            [36.603191001, -1.361443194],
            [36.603041367, -1.360372965],
            [36.602525207, -1.360445093],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK07",
      },
    },
    {
      type: "Feature",
      id: "smd3e14844",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603041367, -1.360372965],
            [36.603191001, -1.361443194],
            [36.603341498, -1.361421493],
            [36.603345811, -1.361512721],
            [36.603494605, -1.361491502],
            [36.603734139, -1.36027616],
            [36.603041367, -1.360372965],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK06",
      },
    },
    {
      type: "Feature",
      id: "smf9b08334",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603683271, -1.356553525],
            [36.603826111, -1.357711118],
            [36.604208734, -1.357663932],
            [36.604430972, -1.356349307],
            [36.604430972, -1.356349307],
            [36.604265608, -1.356366894],
            [36.604196942, -1.356482062],
            [36.603683271, -1.356553525],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK31",
      },
    },
    {
      type: "Feature",
      id: "sm0e46ae62",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603826111, -1.357711118],
            [36.603683271, -1.356553525],
            [36.603130173, -1.356630472],
            [36.603271953, -1.35777946],
            [36.603826111, -1.357711118],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK30",
      },
    },
    {
      type: "Feature",
      id: "sm0759976b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603271953, -1.35777946],
            [36.603130173, -1.356630472],
            [36.602543093, -1.356712149],
            [36.602701458, -1.35784982],
            [36.603271953, -1.35777946],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK29",
      },
    },
    {
      type: "Feature",
      id: "sm448f954b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602701458, -1.35784982],
            [36.602543093, -1.356712149],
            [36.601990137, -1.356789076],
            [36.602147306, -1.35791816],
            [36.602701458, -1.35784982],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK28",
      },
    },
    {
      type: "Feature",
      id: "sm9cccdcbc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602147306, -1.35791816],
            [36.601990137, -1.356789076],
            [36.601429797, -1.356867033],
            [36.601568315, -1.357989566],
            [36.602147306, -1.35791816],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK27",
      },
    },
    {
      type: "Feature",
      id: "smb0c6b127",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601568315, -1.357989566],
            [36.601429797, -1.356867033],
            [36.600887148, -1.356942527],
            [36.601024624, -1.358056619],
            [36.601568315, -1.357989566],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK26",
      },
    },
    {
      type: "Feature",
      id: "sm9c750e15",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601024624, -1.358056619],
            [36.600887148, -1.356942527],
            [36.600576753, -1.356985711],
            [36.6003156, -1.357218422],
            [36.600371671, -1.358137146],
            [36.601024624, -1.358056619],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK25",
      },
    },
    {
      type: "Feature",
      id: "smdbbbb613",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601067009, -1.359258923],
            [36.600920237, -1.358069492],
            [36.600371671, -1.358137146],
            [36.600431697, -1.359120654],
            [36.600641663, -1.359319442],
            [36.601067009, -1.359258923],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK24",
      },
    },
    {
      type: "Feature",
      id: "sm277acf8e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.600920237, -1.358069492],
            [36.601067009, -1.359258923],
            [36.601566692, -1.359187824],
            [36.601421074, -1.358007727],
            [36.600920237, -1.358069492],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK23",
      },
    },
    {
      type: "Feature",
      id: "smff51e73e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601421074, -1.358007727],
            [36.601566692, -1.359187824],
            [36.602098247, -1.35911219],
            [36.60195385, -1.357942022],
            [36.601421074, -1.358007727],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK22",
      },
    },
    {
      type: "Feature",
      id: "sm92cc6a1b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.60195385, -1.357942022],
            [36.602098247, -1.35911219],
            [36.602587933, -1.359042514],
            [36.602444665, -1.357881488],
            [36.60195385, -1.357942022],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK21",
      },
    },
    {
      type: "Feature",
      id: "sm820d2615",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602444665, -1.357881488],
            [36.602587933, -1.359042514],
            [36.603134882, -1.358964691],
            [36.602992878, -1.357813879],
            [36.602444665, -1.357881488],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK20",
      },
    },
    {
      type: "Feature",
      id: "smbb8bd8b2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602992878, -1.357813879],
            [36.603134882, -1.358964691],
            [36.603639971, -1.358892824],
            [36.603499128, -1.357751445],
            [36.602992878, -1.357813879],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK19",
      },
    },
    {
      type: "Feature",
      id: "smd1df1b28",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603499128, -1.357751445],
            [36.603639971, -1.358892824],
            [36.603792997, -1.35887105],
            [36.603804348, -1.358977705],
            [36.603957342, -1.358945256],
            [36.604208734, -1.357663932],
            [36.603499128, -1.357751445],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK18",
      },
    },
    {
      type: "Feature",
      id: "smfd40d49f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.600899584, -1.356578572],
            [36.600804225, -1.355340193],
            [36.600197926, -1.355396581],
            [36.600255223, -1.356448228],
            [36.600481191, -1.356645317],
            [36.600899584, -1.356578572],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK39",
      },
    },
    {
      type: "Feature",
      id: "smcad2a649",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.600806892, -1.35533991],
            [36.600899584, -1.356578572],
            [36.601433685, -1.356517305],
            [36.601374636, -1.355263351],
            [36.600806892, -1.35533991],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK38",
      },
    },
    {
      type: "Feature",
      id: "smedfcd244",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.601374636, -1.355263351],
            [36.601433685, -1.356517305],
            [36.601997762, -1.356441491],
            [36.60196004, -1.355197687],
            [36.601374636, -1.355263351],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK37",
      },
    },
    {
      type: "Feature",
      id: "sm23088496",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.60196004, -1.355197687],
            [36.601997762, -1.356441491],
            [36.602546024, -1.356360331],
            [36.602536667, -1.355131684],
            [36.60196004, -1.355197687],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK36",
      },
    },
    {
      type: "Feature",
      id: "smcb838a62",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.602536667, -1.355131684],
            [36.602546024, -1.356360331],
            [36.603058931, -1.356298874],
            [36.603064195, -1.355070191],
            [36.602536667, -1.355131684],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK35",
      },
    },
    {
      type: "Feature",
      id: "sm8751aca0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [36.603064195, -1.355070191],
            [36.603058931, -1.356298874],
            [36.603576497, -1.356229312],
            [36.603620499, -1.355000242],
            [36.603064195, -1.355070191],
          ],
        ],
      },
      properties: {
        Unit_Number: "PK34",
      },
    },
  ],
};

export default geojsonData;
